import React, { Component, Fragment } from 'react';
import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import withValidator from '../../models/form/withValidator';
import TrainingPhaseFormCardForm from './TrainingPhaseFormCardForm';
import './TrainingPhaseFormCard.scss';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    header: {
      rules: [
        {
          feedback: 'Header is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class TPPhaseFormCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: { header: '' },
      dropdownOpen: false,
      errorFeedback: {},
      isFormDisabled: true,
      forms: !this.props.initialValues ? '' : this.props.initialValues.forms,
      header: !this.props.initialValues ? '' : this.props.initialValues.header,
      type: !this.props.initialValues ? '' : this.props.initialValues.type,
      weeks: !this.props.initialValues ? '' : this.props.initialValues.weeks,
      hours: !this.props.initialValues || this.props.initialValues.hours == null
        ? ''
        : this.props.initialValues.hours,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({ header: this.state.header });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
  }

  // ----------------------
  // Computed
  // ----------------------

  get hasDOR() {
    return this.state.forms.find(form => form.key === 'dor');
  }

  get hasEOP() {
    return this.state.forms.find(form => form.key === 'eop');
  }

  get hasWOR() {
    return this.state.forms.find(form => form.key === 'wor');
  }

  get hasFTC() {
    return this.state.forms.find(form => form.key === 'ftc');
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  addDOR() {
    this.setState({
      forms: [
        {
          key: 'dor',
          min: 20,
          required: true,
        },
        ...this.state.forms,
      ],
    });
  }

  addEOP() {
    this.setState({
      forms: [
        {
          key: 'eop',
          min: 1,
          required: true,
        },
        ...this.state.forms,
      ],
    });
  }

  addWOR() {
    this.setState({
      forms: [
        {
          key: 'wor',
          min: 4,
          required: true,
        },
        ...this.state.forms,
      ],
    });
  }

  addFTC() {
    this.setState({
      forms: [
        {
          key: 'ftc',
          min: 1,
          required: true,
        },
        ...this.state.forms,
      ],
    });
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    const validated = ['header'];
    if (validated.includes(name)) {
      this.props.validateField(name, value, true);
    }
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      const validated = ['header'];
      if (validated.includes(name)) {
        this.props.validateField(name, value, true);
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const properties = {
      header: this.state.header,
      forms: this.state.forms,
      type: this.state.type,
      weeks: this.state.weeks,
      hours: this.state.hours === '' ? null : this.state.hours,
    };
    this.props.onSave(properties);
  }

  removeForm(index) {
    const forms = [...this.state.forms];
    forms.splice(index, 1);
    this.setState({ forms });
  }

  updateForm(index, min) {
    const forms = [...this.state.forms];
    forms[index].min = min;
    this.setState({ forms });
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <Form
          className="training-phase-form-card"
          noValidate
          onSubmit={event => this.handleSubmit(event)}
        >
          <FormGroup>
            <Label for="header">Header *</Label>
            <Input
              className={this.state.cssValidationClasses.header}
              id="header"
              name="header"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Header"
              type="text"
              value={this.state.header}
            />
            <FormFeedback>{this.state.errorFeedback.header}</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="weeks">Weeks *</Label>
            <Input
              className={this.state.cssValidationClasses.weeks}
              id="weeks"
              name="weeks"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              type="select"
              value={this.state.weeks}
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="hours">Hours</Label>
            <Input
                className={this.state.cssValidationClasses.hours}
                id="hours"
                name="hours"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                type="number"
                value={this.state.hours}
            >
            </Input>
          </FormGroup>
          <div className="list-subheader">
            <h3 className="list-subheader__title text-muted">
              <small>Forms</small>
            </h3>
            <div className="add-form-actions">
              {!this.hasDOR && (
                <button
                  className="button small secondary"
                  onClick={() => this.addDOR()}
                >
                  <i className="fa fa-plus" />
                  <span>Daily Observation Report</span>
                </button>
              )}
              {!this.hasEOP && (
                <button
                  className="button small secondary"
                  onClick={() => this.addEOP()}
                >
                  <i className="fa fa-plus" />
                  <span>End-of-Phase Report</span>
                </button>
              )}
              {!this.hasWOR && (
                <button
                  className="button small secondary"
                  onClick={() => this.addWOR()}
                >
                  <i className="fa fa-plus" />
                  <span>Weekly Observation Report</span>
                </button>
              )}
              {!this.hasFTC && (
                <button
                  className="button small secondary"
                  onClick={() => this.addFTC()}
                >
                  <i className="fa fa-plus" />
                  <span>Field training critique</span>
                </button>
              )}
            </div>
          </div>
          {this.state.forms.length > 0 &&
            this.state.forms.map((form, index) => (
              <TrainingPhaseFormCardForm
                form={form}
                key={parseInt(index, 10)}
                onRemoveForm={() => this.removeForm(index)}
                onUpdateForm={min => this.updateForm(index, min)}
              />
            ))}

          <div className="text-right">
            <button
              className="button primary "
              disabled={this.state.isFormDisabled}
              onClick={event => this.handleSubmit(event)}
            >
              Submit
            </button>
          </div>
        </Form>
      </Fragment>
    );
  }
}

export default withValidator(TPPhaseFormCard, validatorConfig);
